const YOUR_PARTNER_ID = 108564
const HASH_METHOD = "SHA256"
const EMAIL = "webteam@inmusicstore.com"

module.exports = {
    YOUR_PARTNER_ID,
    HASH_METHOD,
    EMAIL,
}
